import { Container, FormControl, InputLabel, MenuItem, Select, styled } from '@mui/material';
import { FIRM_SUMMARY_MOST_RECENT_MEASUREMENT_DATE_SLUG } from 'pages/Firms/common/constants/firmSummary';
import { shortDate } from 'utilities';
import { MeasurementDateOption, SelectFundMeasurementDateProps } from './SelectFundMeasurementDate.props';

const StyledInputLabel = styled(InputLabel)({
  transform: 'translate(0, 24px) scale(1)',
  lineHeight: '1',
  '&.MuiInputLabel-shrink': {
    transform: 'translate(0, 1.5px) scale(0.75)',
  },
});

const StyledSelect = styled(Select)({
  '& .MuiSelect-icon': {
    paddingTop: '2px',
  },
});

const SelectFundMeasurementDate = <T extends MeasurementDateOption>({
  selectedFundMeasurementDateState: { value: selectedFundMeasurementDate, setter: setSelectedFundMeasurementDate },
  uniqueFundMeasurementDatesByDate,
  label,
}: SelectFundMeasurementDateProps<T>) => (
    <Container style={{ width: '300px', marginTop: '2em', marginLeft: '0' }}>
      <FormControl fullWidth>
        <StyledInputLabel id="fund-measurement-date-label">{label ?? 'Fund Measurement Date'}</StyledInputLabel>
        <StyledSelect
          labelId="fund-measurement-date-label"
          value={
            selectedFundMeasurementDate?.id &&
          uniqueFundMeasurementDatesByDate.some(date => date.id === selectedFundMeasurementDate.id)
              ? selectedFundMeasurementDate.id
              : ''
          }
          onChange={e => {
            const selectedId = e.target.value;
            const selectedDate = uniqueFundMeasurementDatesByDate.find(date => date.id === selectedId) || null;
            setSelectedFundMeasurementDate(selectedDate); // is setSelectedReportDate when called from FirmExcelExportDialog
          }}
          variant="standard">
          {uniqueFundMeasurementDatesByDate.map(date => (
            <MenuItem
              key={date.id}
              value={date.id}
              style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}
              title={date.name}>
              {date.date === FIRM_SUMMARY_MOST_RECENT_MEASUREMENT_DATE_SLUG ? date.name : shortDate(date.name)}
            </MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </Container>
  );

export default SelectFundMeasurementDate;
